import { Predictions as PredictionsComponent } from '../components/Predictions'

const Predictions = () => {
  // Using our new Predictions component
  return <PredictionsComponent />
}

export default Predictions